import { render, staticRenderFns } from "./ExchangeComponent.vue?vue&type=template&id=2f21cb50&"
import script from "./ExchangeComponent.vue?vue&type=script&lang=js&"
export * from "./ExchangeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports